var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"person-info"},[_c('div',{staticClass:"person-name"},[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"person-designation",style:({ color: _vm.color })},[_vm._v(" "+_vm._s(_vm.designation)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }